// extracted by mini-css-extract-plugin
export default {"wrapper":"IsbnList_wrapper__iZPRx"};